module.exports = __webpack_public_path__ + "img/part_q_1.1d2df0b1.png";